import React from "react";

const Contact = () => {
  return (
    <div className="contact-page flex flex-col">
      <div className="wrap wrapWidth flex flex-col">
        <div className="page-tag">CONTACTO</div>
        <div className="page-desc">
          Rellena este formulario y nos pondremos en contacto con usted con la
          mayor brevedad posible.
        </div>
      </div>
      <div className="contact-us-sec flex">
        <div className="contact-us flex flex-col rel aic">
          <div className="block flex flex-col abs">
            <div className="blk-tag">Déjanos tu consulta</div>
            <div className="fields">
              <input type="text" className="txt" placeholder="Nombre" />
              <input type="text" className="txt" placeholder="Email" />
              <input type="text" className="txt" placeholder="Telefono" />
              <input type="text" className="txt" placeholder="Asunto" />
            </div>
            <textarea type="text" className="txt" placeholder="Mensaje" />
            <div className="row flex aic">
              <input type="checkbox" className="check-box" />
              <div className="lbl">
                He leido y acepto la política de protección de datos.
              </div>
            </div>
            <div className="action flex aic jc">
              <div className="btn button">Enviar</div>
            </div>
          </div>
        </div>
      </div>
      <div className="frequent-sec flex">
        <div className="wrap wrapWidth flex flex-col">
          <div className="frequent-tag">Consultas frecuentes</div>
          <div className="frequent-desc">
            Toda la información que necesitas para sacar el máximo beneficio a
            nuestro marketplace. Si lo prefieres, escríbenos o déjanos un
            mensaje en nuestro chat online.{" "}
          </div>
          <div className="freq-block">
            <div className="freq-card flex flex-col">
              <div className="freq-tag">Vendedores</div>
              <div className="freq-desc">
                Dudas acerca del proceso de venta, la seleccón de artistas y el
                filtrado de obras.
              </div>
              <div className="action-card flex aic jc">
                <div className="btn button">Consultar</div>
              </div>
            </div>
            <div className="freq-card flex flex-col">
              <div className="freq-tag">Compradores</div>
              <div className="freq-desc">
                Consultas sobre el proceso de compra, las obras de arte y los
                métodos de pago.
              </div>
              <div className="action-card flex aic jc">
                <div className="btn button">Consultar</div>
              </div>
            </div>
            <div className="freq-card flex flex-col">
              <div className="freq-tag">Marketplace</div>
              <div className="freq-desc">
                Consultas más habituales sobre el funcionamiento de nuestro
                marketplace
              </div>
              <div className="action-card flex aic jc">
                <div className="btn button">Consultar</div>
              </div>
            </div>
          </div>
          <div className="action flex aic jc">
            <div className="btn button">Consulta todas nuestras FAQs</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
